import { PropType, defineComponent } from 'vue'

import { CsTag, MsHeadline } from '@sunrise/components'
import { MsDoor, MsFloorPlan, MsImage, MsSurface } from '@sunrise/icons'
import { screenSizeDetection } from '@sunrise/shared'
import { MLM, trackLink } from '@sunrise/tracking'

import { DecoratedEstate } from '../../ts/mapper/decoratedItemEstate.interface'

import MsLikeButton from '../MsLikeButton/MsLikeButton.vue'
import { ComponentName } from './MsRecommenderItem.enum'
import { buildMlmTrackingData, buildTealiumTrackingData } from './MsRecommenderItemTracking'
import MsFallBack from './global-fallback-real-estate.svg?component'

export default defineComponent({
    name: 'MsRecommenderItem',
    components: {
        CsTag,
        MsLikeButton,
        MsFloorPlan,
        MsDoor,
        MsImage,
        MsSurface,
        MsHeadline,
        MsFallBack,
    },
    props: {
        item: { type: Object as PropType<DecoratedEstate>, required: true },
        currentUrl: {
            type: String,
            required: true,
        },
        is: {
            type: String as PropType<keyof HTMLElementTagNameMap>,
            default: 'li',
        },
        isExposeeOnline: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const { isScreenM, isScreenL } = screenSizeDetection()

        function onClickItem(e: MouseEvent): void {
            trackTealium(e)
            trackMlm()
        }

        function trackTealium(e: MouseEvent): void {
            const target = e.currentTarget as HTMLAnchorElement
            const tealiumData = buildTealiumTrackingData(props.item, props.isExposeeOnline)
            trackLink(e, target, [tealiumData])
        }

        function trackMlm(): void {
            const mlmData = buildMlmTrackingData(props.item, props.currentUrl, props.isExposeeOnline)
            MLM.trackClick(mlmData)
        }

        function showLandArea(): boolean {
            return props.item.livingArea === null || props.item.rooms === null
        }

        return {
            onClickItem,
            isScreenM,
            isScreenL,
            ComponentName,
            showLandArea,
        }
    },
})
